var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.563,
    height: 11.119,
    viewBox: "0 0 13.563 11.119",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_56",
    "data-name": "Subtraction 56",
    d: "M-1375.177,143.12h0c-.137-.119-.63-.595-2.392-2.449l-.1-.107-.01-.01c-1.214-1.279-1.824-1.921-2.117-2.294-.2-.255-.2-.276-.2-.48v-.023a.773.773,0,0,1,.777-.812h.017c.251,0,.319,0,.994.669.7.693.8.728,1,.728h.21l.147-.147c.147-.147.15-.285.158-.561,0-.142.007-.338.011-.587.006-.549.009-1.218.009-1.885,0-.585,0-2.365.036-2.669a.829.829,0,0,1,.473-.464,1.534,1.534,0,0,1,.27-.027h.009a.742.742,0,0,1,.7.457l.059.128v5.985c0,2.771,0,4.162-.047,4.547Zm4.568-.008a.789.789,0,0,1-.73-.47l-.059-.128v-6.1c0-2.665,0-4,.046-4.413h.01a.184.184,0,0,1,.058.008c.414.368,4.434,4.564,4.779,4.989a.934.934,0,0,1,.012.673.775.775,0,0,1-.739.491c-.306,0-.361,0-1.038-.671s-.765-.758-1-.758a.512.512,0,0,0-.505.527c0,.044-.006.106-.007.175,0,.105-.008.294-.013.6-.009.517-.015,1.207-.018,1.942v.041c-.008,1.709-.012,2.488-.045,2.635l0,.006,0,.007A.838.838,0,0,1-1370.609,143.112Z",
    transform: "translate(1380 -132)",
    fill: "#1b2737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.b13ae048797ce9fc07e6127dc187c406.svg";
export { ForwardRef as ReactComponent };